<template>
    <div class="info-model">
        <div class="overlay"></div>
        <div class="wallet-modal">
            <div class="title-box">
                <h2 v-text="walletTitle"></h2>
            </div>
            <div class="main-area">
                <canvas v-show="showQrCode" id="qrCode"></canvas>
                <DefaultButton v-for="(wallet, key) in walletOptions" :key="key" class="wallet-button"
                    v-show="!showQrCode" :text="wallet.name" :disabled="disabledWalletButtons"
                    @defaultBtnClick="walletSelect(wallet)">
                </DefaultButton>
            </div>
            <div class="footer-area">
                <h2 v-text="walletFooter"></h2>
                <DefaultButton :text="getString('cancelar')" @defaultBtnClick="cancelDigitalWalletPayment()">
                </DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import QRious from 'qrious'
import eventModule from '@/assets/libs/eventModule'
import Util from '@/assets/libs/util'
import PaymentController from '@/assets/controllers/PaymentController'
import DefaultButton from '@/components/DefaultButton'
import MainTef from '@/assets/tef/MainTef'
import LocaleController from '@/assets/controllers/LocaleController'

export default {
    name: 'WalletModal',
    components: {
        DefaultButton
    },
    props: ['qrCodeEventData'],
    data () {
        return {
            walletTitle: this.getString('leia_o_QR_code'),
            walletFooter: '',
            walletOptions: [],
            showQrCode: false,
            disabledWalletButtons: false
        }
    },
    created () {
        eventModule.$on('titleReceived', this.titleReceived)
        eventModule.$on('optionsReceived', this.optionsReceived)
        eventModule.$on('qrCodeForwarded', this.mountQrCode)
        eventModule.$on('removeQrCode', this.removeQrCode)
        eventModule.$on('footerMessageReceived', this.footerMessageReceived)
    },
    beforeDestroy () {
        eventModule.$off('titleReceived', this.titleReceived)
        eventModule.$off('optionsReceived', this.optionsReceived)
        eventModule.$off('qrCodeForwarded', this.mountQrCode)
        eventModule.$off('removeQrCode', this.removeQrCode)
        eventModule.$off('footerMessageReceived', this.footerMessageReceived)
    },
    mounted () {
        if (this.qrCodeEventData != null) {
            setTimeout(() => {
                this.mountQrCode(this.qrCodeEventData)
            }, 500)
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        titleReceived: function (eventData) {
            this.walletTitle = eventData.title
        },
        footerMessageReceived: function (eventData) {
            this.walletFooter = eventData.message
        },
        optionsReceived: function (eventData) {
            let options = eventData.options.split(';')
            let lastElementIsEmpty = options[options.length - 1] === ''
            if (lastElementIsEmpty) options.pop()

            options.forEach((option, idx, array) => {
                let currentOption = {
                    name: '',
                    code: ''
                }
                let index = option.indexOf(':')
                currentOption.name = option.slice(index + 1)
                currentOption.code = option.slice(0, index)
                array[idx] = currentOption
            })

            options = Util.removePixSaquePixTroco(options)

            this.walletOptions = options
        },
        mountQrCode: function (eventData) {
            if (Util.exibQrCodePinPad()) {
                this.showQrCode = false
                this.$emit('closeWalletModal')
                return
            }
            let qrCodeString = eventData.qrCode
            let qrCode = new QRious({
                element: document.getElementById('qrCode'),
                value: qrCodeString,
                size: 450
            })
            this.showQrCode = true
            this.walletTitle = this.getString('leia_o_QR_code')
        },
        removeQrCode: function () {
            this.closeWalletModal()
        },
        closeWalletModal: function () {
            PaymentController.clearDigitalWallet()
            this.$emit('closeWalletModal')
        },
        walletSelect: function (wallet) {
            if (!this.disabledWalletButtons) {
                PaymentController.setDigitalWallet(wallet.code)
                this.disabledWalletButtons = true
                if (Util.exibQrCodePinPad()) {
                    this.$emit('closeWalletModal')
                }
            }
        },
        cancelDigitalWalletPayment: function () {
            MainTef.stopTransactionTef()
            PaymentController.clearDigitalWallet()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.info-model {
    .wallet-modal {
        pointer-events: auto;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        display: flex;
        flex-direction: column;
        background: white;
        max-height: 1000px;
        max-width: 800px;
        margin: auto;
        border-radius: 10px;

        .title-box {
            background-color: @primary-color;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px 10px 0px 0px;

            h2 {
                color: @white;
                margin: auto;
                font-size: 50px;
            }
        }

        .main-area {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .wallet-button {
                margin: 15px 0px;
            }
        }

        .footer-area {
            height: 200px;
            border-radius: 0px 0px 10px 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;

            h2 {
                color: @black;
                margin: auto;
                font-size: 30px;
            }
        }
    }
}

.overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9;
}

@media (max-width: 698px) {

    // Gertec SK210
    .info-model {
        .wallet-modal {
            max-height: 470px;
            max-width: 370px;

            .title-box {
                height: 50px;

                h2 {
                    font-size: 30px;
                }
            }

            .main-area {
                .wallet-button {
                    margin: 5px 0;
                }

                canvas {
                    width: 250px;
                }
            }

            .footer-area {
                height: 85px;

                h2 {
                    margin-bottom: 10px;
                    font-size: 20px;
                }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .info-model {
        img {
            max-width: 600px;
        }

        .wallet-modal {
            max-height: 1000px;
            max-width: 700px;
            margin: auto 50px;

            .main-area {
                .wallet-button {
                    margin: 5px 0;
                }

                canvas {
                    width: 250px;
                }
            }
        }
    }
}

@media (orientation: landscape) {
    .info-model {
        img {
            max-width: 600px;
        }

        .wallet-modal {
            max-height: 650px;
            max-width: 700px;
            margin: auto;

            .title-box {
                height: 100px;

                h2 {
                    font-size: 35px;
                }
            }

            .main-area {
                .wallet-button {
                    margin: 5px 0;
                }

                canvas {
                    width: 250px;
                }
            }

            .footer-area {
                height: 85px;

                h2 {
                    margin-bottom: 10px;
                    font-size: 20px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/WalletModal.vue